module.exports = __webpack_public_path__ + "static/media/xlsx_icon.2c0201d5.svg";